var OrderNow = (function ($) {

    function handleUpdateOrderNowLinkEvent() {
        $(document).on("changeCartEvent", function (event, data) {
            $.ajax({
                url: "/cart/order/now",
                type: "GET",
                cache: false,
                success: function (orderNowData) {
                    if (orderNowData) {
                        var $orderNowContainer = $(".order-now-container");
                        $orderNowContainer.empty();
                        $orderNowContainer.html(orderNowData);
                        $(".main-page-header-container")[0].classList.add("has-order");
                    }
                }
            });
        });
    }

    return {
        handleUpdateOrderNowLinkEvent: handleUpdateOrderNowLinkEvent
    };

})(jQuery);

$(document).ready(function () {
    OrderNow.handleUpdateOrderNowLinkEvent();
});